import React from 'react';
import { Search, FileSearch, AlertCircle, FileText, Shield } from 'lucide-react';
export function ProcessSection() {
  const steps = [{
    icon: <Search className="h-8 w-8 text-red-500" data-id="element-166" />,
    title: 'Reconnaissance',
    description: 'We gather information about your systems, applications, and networks to understand the attack surface.'
  }, {
    icon: <FileSearch className="h-8 w-8 text-red-500" data-id="element-167" />,
    title: 'Scanning & Enumeration',
    description: 'We identify potential vulnerabilities and entry points using specialized tools and techniques.'
  }, {
    icon: <AlertCircle className="h-8 w-8 text-red-500" data-id="element-168" />,
    title: 'Vulnerability Assessment',
    description: 'We analyze discovered weaknesses to determine their severity and potential impact on your business.'
  }, {
    icon: <FileText className="h-8 w-8 text-red-500" data-id="element-169" />,
    title: 'Reporting',
    description: 'We provide detailed documentation of findings with clear remediation recommendations.'
  }, {
    icon: <Shield className="h-8 w-8 text-red-500" data-id="element-170" />,
    title: 'Remediation Support',
    description: 'We assist your team in addressing the identified vulnerabilities and validate the fixes.'
  }];
  return <section id="process" className="py-20 bg-gray-900" data-id="element-171">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-172">
        <div className="text-center mb-16" data-id="element-173">
          <h2 className="text-3xl md:text-4xl font-bold text-white" data-id="element-174">
            Our Penetration Testing Process
          </h2>
          <p className="mt-4 max-w-3xl mx-auto text-gray-400 text-lg" data-id="element-175">
            We follow a structured methodology to ensure comprehensive security
            assessment and actionable results.
          </p>
        </div>
        <div className="relative" data-id="element-176">
          {/* Connection line */}
          <div className="hidden md:block absolute left-1/2 top-0 bottom-0 w-0.5 bg-gray-700 transform -translate-x-1/2" data-id="element-177"></div>
          <div className="space-y-16" data-id="element-178">
            {steps.map((step, index) => <div key={index} className={`relative flex flex-col ${index % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'} items-center`} data-id="element-179">
                <div className="md:w-1/2 mb-8 md:mb-0 md:px-8" data-id="element-180">
                  <div className={`${index % 2 === 0 ? 'md:text-right' : 'md:text-left'}`} data-id="element-181">
                    <h3 className="text-2xl font-bold text-white mb-3" data-id="element-182">
                      {step.title}
                    </h3>
                    <p className="text-gray-400" data-id="element-183">{step.description}</p>
                  </div>
                </div>
                <div className="md:absolute md:left-1/2 md:transform md:-translate-x-1/2 z-10" data-id="element-184">
                  <div className="w-16 h-16 rounded-full bg-gray-800 border-4 border-gray-700 flex items-center justify-center" data-id="element-185">
                    {step.icon}
                  </div>
                </div>
                <div className="md:w-1/2 md:px-8" data-id="element-186">
                  {/* Empty div to maintain layout */}
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}